import * as Sentry from "@sentry/react";

export default function configureSentry() {
  Sentry.init({
    dsn: "https://e358d4a2a7a24f6daadb05e690243ade@sentry.flexi-apps.com/71",
  });
  return Sentry;
}
